import { SaldoICRecord } from "@commons/mapping/SaldoICRecord";
import { IstitutiContrParams, listIstitutiContrattuali, listRiepilogoIC, RiepilogoICParams } from "@commons/services/presenze_api/riepilogoIC.api";
import { IstitutoContrattualeRecord } from "@commons/mapping/IstitutoContrattualeRecord";

export type TabellaICRecord = IstitutoContrattualeRecord;

export class SituazioneIC {
    public idAziendaTabelle: number;
    public tabellaIC: TabellaICRecord[];
    public saldiIC: SaldoICRecord[];

    constructor(idAziendaTabelle: number) {
        this.idAziendaTabelle = idAziendaTabelle;
        this.tabellaIC = [];	// array istituti contrattuali dell'azienda
        this.saldiIC = [];
    }

    static caricaIstituti = (that: SituazioneIC, params: IstitutiContrParams) => {
        that.tabellaIC = [];
        return listIstitutiContrattuali(params!).then((data: IstitutoContrattualeRecord[] | null) => {
            if (data)
                for (let ind0 = 0; ind0 < data.length; ++ind0) {
                    const temp = {
                        codIstituto: data[ind0].id,
                        descrizione: data[ind0].descrizione,
                        descrizione2: data[ind0].descrizione2,
                        showFlags: IstitutoContrattualeRecord.getFieldList(data[ind0]),
                        statusGiustificativi: data[ind0].statusGiustificativi || []
                    };
                    that.tabellaIC.push(IstitutoContrattualeRecord.factory(temp));
                }
        });
    };

    static caricaSaldi = (that: SituazioneIC, params: RiepilogoICParams) => {

        // Carico saldi alla data per il lavoratore indicato da <lavoratore>
        that.saldiIC = [];
        return listRiepilogoIC(params!).then((data) => {
            if (data) {
                that.saldiIC = data;
                for (let ind0 = 0; ind0 < that.tabellaIC.length; ++ind0) {
                    that.tabellaIC[ind0].saldo = SaldoICRecord.cercaSaldo(that.tabellaIC[ind0].codIstituto!, that.saldiIC);
                }
            }
        });
    };
}